export default __webpack_public_path__ + "94269d811334f5f42cdfb9471f7c53e4.png";